import { Injectable } from '@angular/core';
import { MetadataLoadingService } from '@carm/_core/metadata/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as MetadataActions from '../actions/metadata.actions';

@Injectable()
export class MetadataEffects {

  constructor(private actions$: Actions,
              private metadataService: MetadataLoadingService) {}

  loadAllMetaData$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(MetadataActions.loadAllMetadata),
        switchMap( (props) =>
          this.metadataService.getAllMetadata(props.lang).pipe(
              map((data) =>
                MetadataActions.loadAllMetadataSuccess({data}),
              ),
              catchError((error) => of(MetadataActions.loadAllMetadataFailure({ error }))),
          ),
        ),
      );
  });

  loadSingleMetaData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MetadataActions.loadSingleMetadata),
      switchMap( (props) =>
        this.metadataService.getSingleMetadata(props.id, props.lang).pipe(
          map((data) => {
            return MetadataActions.loadSingleMetadataSuccess({data});
           }),
          catchError((error) => of(MetadataActions.loadSingleMetadataFailure({ error }))),
        ),
      ),
    );
});

}
